export const ON_THE_WHOLE_STRATUM = {
    id: -100,
    title: 'В целом',
    width: 100,
};

export const WITHOUT_STRATUM = {
    id: -200,
    title: 'Без пласта',
};

export const SEPARATE_STRATUM = {
    id: 'separateStratum',
    title: 'Отдельный пласт',
    width: 150,
};
